import { render, staticRenderFns } from "./StepWaiting.vue?vue&type=template&id=f2730748&"
import script from "./StepWaiting.vue?vue&type=script&lang=js&"
export * from "./StepWaiting.vue?vue&type=script&lang=js&"
import style0 from "./StepWaiting.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports